import { Sun } from "./Hero.tsx"
import { contact, education, experience, identity, skills, work } from "./content/profile.ts"

/** The page: the Sun sets as you read. */
export function Page() {
  return (
    <>
      <Sun />
      <main className="day">
        <header className="hour hour--noon" id="top">
          <h1 className="name">{identity.name}</h1>
          <p className="role">
            {identity.role} ·{" "}
            <a href={identity.companyUrl} rel="me">
              {identity.company}
            </a>{" "}
            · {identity.location}
          </p>
          <a className="hint" href="#work" aria-label="Scroll to read more">
            <span className="hint__glyph" aria-hidden="true" />
            <span>read on</span>
          </a>
        </header>

        <section className="hour" id="work" aria-labelledby="h-work">
          <Rule />
          <h2 id="h-work">Work</h2>
          <ol className="ledger">
            {work.map((w) => (
              <li key={w.name} className="entry">
                <div className="entry__head">
                  <h3>{w.url ? <a href={w.url}>{w.name}</a> : w.name}</h3>
                  <span className="entry__context">{w.context}</span>
                </div>
                <p>{w.line}</p>
              </li>
            ))}
          </ol>
        </section>

        <section className="hour" id="experience" aria-labelledby="h-experience">
          <Rule />
          <h2 id="h-experience">Experience</h2>
          {experience.map((e) => (
            <article key={e.org} className="entry">
              <div className="entry__head">
                <h3>
                  {e.org} <span className="entry__title">— {e.title}</span>
                </h3>
                <span className="entry__context">{e.dates}</span>
              </div>
              {e.note ? <p className="entry__note">{e.note}</p> : null}
              <ul className="points">
                {e.points.map((pt) => (
                  <li key={pt}>{pt}</li>
                ))}
              </ul>
            </article>
          ))}
          <dl className="facts">
            {education.map((ed) => (
              <div key={ed.org} className="facts__row">
                <dt>{ed.org}</dt>
                <dd>
                  {ed.detail}
                  {ed.dates ? <span className="entry__context"> · {ed.dates}</span> : null}
                </dd>
              </div>
            ))}
          </dl>
          <dl className="facts facts--skills">
            {skills.map(([k, v]) => (
              <div key={k} className="facts__row">
                <dt>{k}</dt>
                <dd>{v}</dd>
              </div>
            ))}
          </dl>
        </section>

        <footer className="hour hour--night" id="contact" aria-labelledby="h-contact">
          <Rule />
          <h2 id="h-contact">Find me @</h2>
          <ul className="contact">
            {contact.map((c) => (
              <li key={c.label}>
                <span className="contact__label">{c.label}</span>
                <a href={c.href} rel="me noopener">
                  {c.value}
                </a>
              </li>
            ))}
          </ul>
        </footer>
      </main>
    </>
  )
}

function Rule() {
  return <div className="rule" aria-hidden="true" />
}
